<template>
  <div>
    <Modal
      id="business-switch-modal"
      :closeable="true"
      :showModal="businessSwitchModalVisible"
      @close="closeBusinessSwitchModal"
      :optionalStyles="modalStyles()"
      >
        <template #header>
          <span class="text-xl">Select Business</span>
        </template>
        <template #body>
          <div class="mt-4 d-flex justify-start">
            <p>Choose which application you wish to work on:</p>
          </div>
          <div class="d-flex flex-row mt-3 p-2"
          v-for="borrower in borrowers" :key="borrower.id"
          :class="{'checked-radio-item': selectedBusiness === borrower.id, 'unchecked-radio-item': selectedBusiness !== borrower.id}">

              <input
                  :id="borrower.id"
                  class="check-box pr-4"
                  type="radio"
                  name="business-switch"
                  v-model="selectedBusiness"
                  :value="borrower.id"
                  :checked="selectedBusiness === borrower.id ? true : false"
              />
              <label :for="borrower.id" class="ml-2">{{borrower.name}}</label>
          </div>
        </template>
        <template #footer>
          <div class="modal-footer">
              <a v-if="!loading" href="javascript:" style="margin-right: 20px;" @click="closeBusinessSwitchModal()">Cancel</a>
              <button type="button" @click="switchBusiness()" :disabled="loading" class="btn btn-primary">
                  <span v-if="!loading">Select</span>
                    <span v-if="loading">Loading...</span>
              </button>
          </div>
        </template>
    </Modal>
  </div>
</template>

<script>
import { mapState } from 'pinia'
import Modal from '~/components/modal.vue'
import get from 'lodash/get'
import { useBorrowerStore } from '~/store/borrower'
import { useUserStore } from '~/store/user'
import { useQuestionsStore } from '~/store/questions'
import { useBusinessSwitchStore } from '~/store/business-switch'

export default {
  name: 'BusinessSwitchModal',
  components: {
    Modal,
  },
  data() {
    return {
      submitting: false,
      currentSelectedBusiness: null,
      loadingBorrower: false
    }
  },
  computed: {
    ...mapState(useUserStore, {
      borrowers: (store) => store.borrowers
    }),
    ...mapState(useQuestionsStore, ['stateAnswers']),
    ...mapState(useBorrowerStore, {
      borrowerId: (state) => get(state, 'borrowerId')
    }),
    ...mapState(useBusinessSwitchStore, {
      businessSwitchModalVisible: (store) => get(store, 'businessSwitchModalVisible'),
    }),
    selectedBusiness: {
      get() {
          let result = this.borrowers[0].id
          if (this.currentSelectedBusiness) {
              result = this.currentSelectedBusiness
          } else {
              result = this.borrowerId
          }
        return result
      },
      set(borrowerId) {
        this.currentSelectedBusiness = borrowerId;
      }
    },
    loading: {
      get() {
          return this.loadingBorrower
      },
      set(value) {
          this.loadingBorrower = value
      }
    },
  },
  methods: {
    async switchBusiness() {
      await this.setBorrowerCookie()

      if (this.selectedBusiness !== this.borrowerId) {
        await this.reloadPage()
      } else {
        await this.closeBusinessSwitchModal()
      }
    },
    closeBusinessSwitchModal() {
      useBusinessSwitchStore(this.$pinia).businessSwitchModalToggle(false)
    },
    async setBorrowerCookie() {
      await useBusinessSwitchStore(this.$pinia).setBorrowerIdCookie(this.selectedBusiness)
    },
    async reloadPage() {
      this.loading = true;
      location = '/bp/resume-app'
    }
  },
  setup() {
    function modalStyles() {
      return {
        'modal-wrapper': {
          'transform': 'translateY(70%)'
        },
      }
    }

    return {
      modalStyles
    }
  }
}
</script>
<style scoped lang="scss">
@import "elements/lendio-environment";
.checked-radio-item {
  border: 2px solid #1270ED;
  border-radius: 8px;
}

#business-switch-modal span{
  label {
    padding-left: 12px;
  }
}

.unchecked-radio-item {
  border: 2px solid transparent;
  border-radius: 8px;
}
</style>
